// src/pages/About.jsx
import React from "react";
import aboutImg from "../assets/about-4.png"; // hero + image blocks
// If you have a separate donations background, import it and swap below.
// import donateBg from "../assets/donate-hero.jpg";

const Breadcrumb = ({ items, onNav }) => (
  <div className="breadcrumb bg-gray-50 py-4">
    <div className="w-full px-4">
      <div className="flex items-center space-x-2 text-sm">
        {items.map((it, i) => (
          <div key={it.id} className="flex items-center space-x-2">
            {i > 0 && <span className="text-[#A67C37]">›</span>}
            <button
              onClick={() => onNav?.(it.id)}
              className={`transition-colors ${i === items.length - 1
                  ? "text-[#A67C37] font-semibold"
                  : "text-gray-600 hover:text-[#A67C37]"
                }`}
            >
              {it.label}
            </button>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default function AboutPage({ setCurrentPage }) {
  return (
    <>
      <Breadcrumb
        items={[
          { id: "home", label: "Home" },
          { id: "about", label: "About" },
        ]}
        onNav={setCurrentPage}
      />

      {/* ---------- Top About (title, banner, quote, long text, list) ---------- */}
      <section className="about py-16 bg-white">
        <div className="w-full px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">About BICC</h2>
            <p className="text-gray-600 text-lg">
              It is the responsibility of every Muslim to serve for DEEN
            </p>
          </div>

          <div className="h-70 rounded-lg shadow-lg mb-8 overflow-hidden">
            <img src={aboutImg} alt="About BICC" className="h-full w-full object-cover" />
          </div>

          <div className="text-center mb-12">
            <blockquote className="text-[#D2B995] italic text-lg font-semibold border-l-4 border-[#D2B995] pl-4 inline-block text-left">
              Prophet Muhammad (S.A.W.W): &quot;If you wish for Allah to multiply your
              wealth, then purify it (through zakat).&quot;
            </blockquote>
          </div>

          <div className="max-w-4xl mx-auto">
            <h3 className="text-4xl font-bold mb-6 text-black">About Us</h3>
            <p className="text-black mb-8  leading-relaxed">
              Bramalea Islamic Cultural Centre (BICC) is a registered not-for-profit charitable organization
              located at 25 Kings Cross Road in Brampton. We serve more than 1,200 individuals living and/or
              working in the Region of Peel in several programs and activities. Our goal is to establish an
              Islamic Cultural &amp; Community Centre where Islamic faith is instilled into hearts of Muslims
              of all ages and socio-economic conditions of people who are in need are improved.
            </p>
            <h4 className="text-4xl font-bold mb-6 text-black">Our programs components:</h4>
            <ul className="list-disc list-inside space-y-3 text-black mb-8">
              <li>Islamic religion and cultural programs.</li>
              <li>
                Educational Support program that increases vulnerable students&apos; access, success, and completion.
              </li>
              <li>
                Workforce Readiness Program to increase income and employment for youth, unemployed and ethnic or
                racial groups and enhance employment opportunities.
              </li>
              <li>Family and Social Support program to increase social connections and supports.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ---------- Mission & Vision cards (from your image) ---------- */}
      <section className="py-16 bg-[#F5F1E8]">
        <div className="w-full px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Mission */}
            <div className="bg-white rounded-2xl shadow-[0_10px_25px_rgba(0,0,0,0.08)] p-8">
              <h3 className="text-2xl font-bold text-[#D2B995] mb-4">Our Mission</h3>
              <p className="text-black leading-relaxed">
                To advance religion by establishing a facility to be used for Islamic religion &amp; cultural
                programs, workshops, conducting prayer services and Qur&apos;anic studies by the general Muslim
                community of Bramalea City Centre. Improving socio-economic conditions in the Region of Peel by
                operating, establishing, maintaining, and supporting a community center for persons who are in need.
              </p>
            </div>

            {/* Vision */}
            <div className="bg-white rounded-2xl shadow-[0_10px_25px_rgba(0,0,0,0.08)] p-8">
              <h3 className="text-2xl font-bold text-[#D2B995] mb-4">Our Vision</h3>
              <p className="text-black leading-relaxed">
                To be an exemplary and unifying Islamic organization in Canada that contributes to the betterment
                of the Muslim community and society at large. Our Centre to be used by marginalized population
                groups in the Region of Peel who have lowest socio-economic status to improve their education,
                employment, income and get family and social supports — the social and economic factors that
                influence our communities. Strengthen and develop Canadian Muslim communities. Achieve organizational
                excellence through operational efficiency, transparency, accountability, high-performance, effective
                communication, and financial stability.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- Priorities & Desired Outcomes (from your image) ---------- */}
      <section className="py-16 bg-white relative">
        {/* subtle watermark mandala if you want one via CSS background-image */}
        <div className="w-full px-14">
          <h2 className="text-4xl font-extrabold text-gray-700 mb-6">Priorities</h2>
          <ul className="list-disc list-inside text-gray-800 text-lg space-y-3 mb-12">
            <li>
              <span className="font-semibold">Serve the Community</span> — 35%
            </li>
            <li>
              <span className="font-semibold">Populate Our Musallah and Strengthen Our Centre</span> — 25%
            </li>
            <li>
              <span className="font-semibold">Boost our sense of belonging</span> — 25%
            </li>
            <li>
              <span className="font-semibold">The state-of-the-art Islamic Centre</span> — 15%
            </li>
          </ul>

          <h2 className="text-4xl font-extrabold text-gray-700 mb-4">Desired Outcomes</h2>
          <p className="text-black max-w-5xl font-semibold leading-relaxed">
            A Centre where everyone enjoys a sense of belonging and is set up for success here and hereafter.
            Islamic faith is preserved for future generations. Muslims’ contributions to the well-being of the
            community are heartfelt and appreciated.
          </p>
        </div>
      </section>

      {/* ---------- Your Donations banner + CTA (from your image) ---------- */}
      <section
        className="relative py-16 bg-center bg-cover"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,.55), rgba(0,0,0,.55)), url(${aboutImg})`,
          // swap aboutImg with your donations hero if needed
        }}
      >
        <div className="w-full px-4 text-center text-white">
          <h2 className="text-4xl font-extrabold mb-4">Your Donations</h2>
          <p className="text-xl font-semibold mb-6">
            Please let’s work together to make our desired outcomes a reality. Donate Generously.
          </p>
          <button
            className="px-8 py-3 rounded-xl bg-[#D2B995] text-gray-900 font-semibold hover:bg-[#C4A882] transition-colors"
            onClick={() => window.open("https://app.irm.io/bramaleaicc.ca", "_blank", "noopener,noreferrer")}
          >
            Donate Now
          </button>

        </div>
      </section>

      {/* ---------- Services pills (from your image) ---------- */}
      <section className="py-16 bg-[#F5F1E8]">
        <div className="w-full px-4">
          <div className="text-center mb-10">
            <h2 className="text-4xl font-extrabold text-gray-800">Services</h2>
            <p className="text-black mt-2">
              It is the responsibility of every Muslim to serve for DEEN
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {[
              "5 Daily Prayers",
              "2 Jumu'ah Prayers",
              "Taraweeh in Ramadan",
              "Sisters Friday Night",
              "Arabic Courses",
              "Special Events",
            ].map((label) => (
              <button
                key={label}
                className="uppercase tracking-wide font-extrabold text-white bg-[#c9b088] hover:bg-[#bfa476]
                           px-6 py-5 rounded-2xl shadow transition"
                onClick={() => setCurrentPage?.("services")}
              >
                {label}
              </button>
            ))}
          </div>

          <div className="text-center mt-10">
            <button
              className="px-8 py-3 rounded-xl bg-[#D2B995] text-white font-semibold hover:bg-[#C4A882] transition-colors"
              onClick={() => setCurrentPage?.("services")}
            >
              Read More
            </button>
          </div>
        </div>
      </section>

      {/* <section className="about py-16 bg-white">
        <div className="w-full px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="bg-gray-200 h-80 rounded-lg shadow-lg overflow-hidden flex items-center justify-center">
              <img src={aboutImg} alt="Mosque" className="h-full w-full object-cover" />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">About BICC</h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Bramalea Islamic Cultural Centre (BICC) is a registered not-for-profit charitable organization
                located at 25 Kings Cross Road in Brampton. We serve more than 1,200 individuals living and/or
                working in the Region of Peel in several programs and activities.
              </p>
              <blockquote className="border-l-4 border-[#D2B995] pl-4 italic text-[#D2B995] mb-6">
                Prophet Muhammad (S.A.W.W): &quot;If you wish for Allah to multiply your wealth, then purify it
                (through zakat).&quot;
              </blockquote>
              <div className="flex gap-3">
                <button
                  onClick={() => setCurrentPage?.("services")}
                  className="bg-[#D2B995] text-white px-8 py-3 rounded-lg hover:bg-[#C4A882] transition-colors font-semibold"
                >
                  Explore Services
                </button>
                <button
                  onClick={() => setCurrentPage?.("contact")}
                  className="border border-[#D2B995] text-[#A67C37] px-8 py-3 rounded-lg hover:bg-[#F5F1E8] transition-colors font-semibold"
                >
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
}
